import { createAction } from 'redux-actions'
import * as c from './constants'

export const getWidgetData = createAction(c.GET_WIDGET_DATA,
  async (client) => {
    try {
      const response = await client.request({
        method: 'GET',
        url: '/v2/widget'
      })
      return response.data
    } catch (err) {
      throw new Error('Could not fetch widget data:', err)
    }
  }
)

export const saveRestoreId = createAction(c.SAVE_RESTORE_ID,
  async (client, restoreId) => {
    try {
      const response = await client.request({
        method: 'POST',
        url: '/v1/widget',
        data: { restoreId: restoreId }
      })
      return response.data
    } catch (err) {
      throw new Error('Could not save restoreId:', err)
    }
  }
)
